import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Link, withRouter } from 'react-router-dom'

//i18n
import { withTranslation } from 'react-i18next'

class SecuazContent extends Component {
	constructor(props) {
		super(props)
		this.refDiv = React.createRef()
	}

	render() {
		const { t } = this.props

		return (
			<React.Fragment>
				<li>
					<Link to="/#" className="has-arrow">
						<i className="bx bx-store" />
						<span>{t('management', { ns: 'naming' })}</span>
					</Link>
					<ul className="sub-menu" aria-expanded="false">
						<li>
							<Link to="/offer-list">{t('offers', { ns: 'naming' })}</Link>
						</li>
					</ul>
				</li>
			</React.Fragment>
		)
	}
}

SecuazContent.propTypes = {
	location: PropTypes.object,
	t: PropTypes.any,
	type: PropTypes.string,
	initMenu: PropTypes.func,
}

export default withRouter(withTranslation()(SecuazContent))
